export const staticRoutes: AppRoute.RowRoute[] = [
  {
    name: 'chat',
    path: '/chat',
    title: '聊天列表',
    requiresAuth: true,
    componentPath: '/chat/index.vue',
    id: 1,
    pid: null,

  },
  {
    name: 'detail',
    path: '/detail',
    title: '聊天',
    requiresAuth: true,
    componentPath: '/detail/index.vue',
    id: 2,
    pid: null,
  },

]
